import React from 'react';
import { TableName } from 'v2/models';
import { LinkedEntityType } from '../../../../enums';
import { ActivityBodyProps } from '../../../../types';
import { getLinkedEntityType } from '../../../../utils';
import {
  ContactLinkCreatedBody,
  DatasetLinkCreatedBody,
  DataVendorLinkCreatedBody,
} from './components';

export function LinkCreatedActivityBody({ activity }: ActivityBodyProps) {
  const linkedEntityType = getLinkedEntityType(activity);
  if (linkedEntityType === null) return null;

  const relationship = activity.relationships
    .filter((relationship) => relationship.table_name !== TableName.Searches)
    .at(-1);

  if (relationship === undefined) return null;

  switch (linkedEntityType) {
    case LinkedEntityType.DATA_VENDOR:
      return <DataVendorLinkCreatedBody relationship={relationship} />;

    case LinkedEntityType.CONTACT:
      return <ContactLinkCreatedBody relationship={relationship} />;

    case LinkedEntityType.DATASET:
      return <DatasetLinkCreatedBody relationship={relationship} />;

    default:
      return null;
  }
}
